import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { cn } from '../lib/cn.js';
const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-3xl',
    xl: 'max-w-5xl',
};
export function Modal({ open, onClose, title, description, size = 'md', children, footer, dismissible = true, className, }) {
    useEffect(() => {
        if (!open || !dismissible) {
            return;
        }
        const onKey = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [open, dismissible, onClose]);
    useEffect(() => {
        if (open) {
            const previous = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = previous;
            };
        }
        return undefined;
    }, [open]);
    if (!open) {
        return null;
    }
    return (_jsxs("div", { role: "presentation", className: "fixed inset-0 z-ax-modal flex items-center justify-center p-4", onClick: dismissible ? onClose : undefined, children: [_jsx("div", { className: "absolute inset-0 bg-ax-obsidian/80 backdrop-blur-sm animate-ax-fade-in", "aria-hidden": "true" }), _jsxs("div", { role: "dialog", "aria-modal": "true", "aria-labelledby": title ? 'ax-modal-title' : undefined, "aria-describedby": description ? 'ax-modal-desc' : undefined, className: cn('relative w-full bg-ax-graphite border border-ax-line rounded-ax-lg shadow-ax-lg', 'animate-ax-fade-in', sizeClasses[size], className), onClick: (e) => e.stopPropagation(), children: [(title || description) && (_jsxs("div", { className: "px-6 pt-6 pb-4 border-b border-ax-line", children: [title && (_jsx("h2", { id: "ax-modal-title", className: "font-display text-xl text-ax-text-primary tracking-tight", children: title })), description && (_jsx("p", { id: "ax-modal-desc", className: "mt-1 ax-body-sm text-ax-text-tertiary", children: description }))] })), _jsx("div", { className: "px-6 py-5", children: children }), footer && (_jsx("div", { className: "px-6 pb-6 pt-4 border-t border-ax-line flex items-center justify-end gap-2", children: footer }))] })] }));
}
//# sourceMappingURL=Modal.js.map